const React = require('react');


/* eslint-disable */
module.exports = (props) => {
  return (
    <svg
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`dB h16 strokeCT>path ` + (props.className || '')}
    >
      <path
        d="M1 4.55556V13.4444C1 15.4089 4.184 17 8.11111 17C12.0382 17 15.2222 15.4089 15.2222 13.4444V4.55556M1 4.55556C1 6.52 4.184 8.11111 8.11111 8.11111C12.0382 8.11111 15.2222 6.52 15.2222 4.55556M1 4.55556C1 2.59111 4.184 1 8.11111 1C12.0382 1 15.2222 2.59111 15.2222 4.55556M15.2222 9C15.2222 10.9644 12.0382 12.5556 8.11111 12.5556C4.184 12.5556 1 10.9644 1 9"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
